import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, ElementRef, forwardRef, Injector, OnInit } from '@angular/core'
import { NG_VALUE_ACCESSOR, NgControl } from '@angular/forms'
import { CorpSpinnerComponent } from '@corporate-tailwind/component'
import { CorpControlTitleComponent } from '../common/corp-control-title/corp-control-title.component'
import { CorpControlCommonComponent } from '../common/corp-control-common/corp-control-common.component'
import { ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'corp-input',
    standalone: true,
    templateUrl: 'corp-input.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, CorpControlTitleComponent, CorpSpinnerComponent],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CorpInputComponent),
            multi: true,
        },
    ],
})
export class CorpInputComponent extends CorpControlCommonComponent implements OnInit {

    constructor(

        private injector: Injector) {
        super()
    }

    ngOnInit(): void {
        const ngControl = this.injector.get(NgControl, null)
        this.setNgControl(ngControl)
    }
}

